import adria from './assets/cast/adria_lamorticella.webp';
import anthony from './assets/cast/anthony_van_winkle.webp';
import claudine from './assets/cast/claudine_mboligikpelani_nako.webp';
import doug from './assets/cast/doug_willott.webp';
import ian from './assets/cast/ian_schempp.webp';
import kat from './assets/cast/kat_schelonka.webp';
import mike from './assets/cast/mike_murphy.webp';
import nathan from './assets/cast/nathan_cox.webp';
import nick from './assets/cast/nick_edwards.webp';
import preston from './assets/cast/preston_mcneil.webp';
import randy from './assets/cast/randy_miller.webp';
import rob from './assets/cast/rob_scherzer.webp';
import saina from './assets/cast/saina_hussain.webp';
import stephani from './assets/cast/stephani_thompson.webp';

import gallery01 from './assets/gallery/2013_2.webp';
import gallery02 from './assets/gallery/2018_15.webp';
import gallery03 from './assets/gallery/2018_9.webp';
import gallery04 from './assets/gallery/2018_11.webp';
import gallery05 from './assets/gallery/2013_7.webp';
import gallery06 from './assets/gallery/2012_4.webp';
import gallery07 from './assets/gallery/2012_2.webp';
import gallery08 from './assets/gallery/2018_10.webp';
import gallery09 from './assets/gallery/2018_5.webp';
import gallery10 from './assets/gallery/2018_7.webp';
import gallery11 from './assets/gallery/2013_6.webp';
import gallery12 from './assets/gallery/2013_5.webp';
import gallery13 from './assets/gallery/2012_9.webp';
import gallery14 from './assets/gallery/2013_1.webp';
import gallery15 from './assets/gallery/2018_12.webp';
import gallery16 from './assets/gallery/2012_1.webp';
import gallery17 from './assets/gallery/2018_17.webp';
import gallery18 from './assets/gallery/2018_18.webp';
import gallery19 from './assets/gallery/2012_8.webp';
import gallery20 from './assets/gallery/2012_7.webp';
import gallery21 from './assets/gallery/2018_14.webp';
import gallery22 from './assets/gallery/2012_10.webp';
import gallery23 from './assets/gallery/2018_13.webp';
import gallery24 from './assets/gallery/2012_11.webp';
import gallery25 from './assets/gallery/2018_4.webp';

export const siteLinks = {
  ticketUrl:
    'https://www.strangertickets.com/events/159960510/uncle-mike-ruins-christmas',
  theatreUrl:
    'https://www.google.com/maps/place/Erickson+Theatre/@47.6146665,-122.3217441,15z',
  youtubeUrl: 'https://www.youtube.com/embed/a365bLalJxM',
  spotifyUrl:
    'https://open.spotify.com/embed/playlist/1WrE2Q6rK5MJj9Z3sZO42R?utm_source=generator',
};

export const contacts = [
  { label: 'General inquiry', email: 'unclemikeruinschristmas@gmail.com' },
];

export const castMembers = [
  {
    name: 'Mike Murphy',
    pronouns: 'he/him',
    role: 'Founder, Producer, Uncle Mike',
    image: mike,
    bio: 'Uncle Mike himself. Hi. My name is Mike. I got a wife, two kids, and I work at the Union factory.',
  },
  {
    name: 'Nathan Cox',
    pronouns: 'he/him',
    role: 'Player',
    image: nathan,
    bio: 'Nathan Cox is a teacher, director, and improviser of 20 years. He has created and performed in A Tribe Called Yes, Britain’s Baking Challenge, Claim of Thrones, Inside Voices, and Shot Prov. You can occasionally catch him in Jet City’s We Have Some Notes and Sound & Fury at CSz Seattle. Nathan is happy to be back with UMRX for another sick and twisted holiday season.',
  },
  {
    name: 'Nick Edwards',
    pronouns: 'he/him',
    role: 'Artistic Director, Producer, Narrator, Player',
    image: nick,
    bio: 'Nick Edwards began his Uncle Mike journey at the tender age of zero when he was born on Christmas. A few years later, in fourth grade, he performed his first improv scene: miming a pet turtle pooping in his hands. Not much has changed. He works as a director, writer, and actor of scripted and unscripted work, and takes great joy in directing this show with this team.',
  },
  {
    name: 'Saina Hussain',
    pronouns: 'she/her',
    role: 'Player',
    image: saina,
    bio: 'Saina is an ensemble member at Jet City Improv, where you can catch her performing in flagship shows, teaching classes and workshops, and doing camp shows with Improv4Good. She is full of merry to spread the cheers and tears of the holidays with this super-talented group of improvisers.',
  },
  {
    name: 'Adria LaMorticella',
    pronouns: 'she/her',
    role: 'Player',
    image: adria,
    bio: 'Adria came to Uncle Mike a virgin and expected to leave a defiled husk of her former self. Her extremely wholesome credits include Luchadora! and A Tale of Peter Rabbit at Seattle Children’s Theatre. She writes and performs with sketch group Better On Paper, dances with BFFervescent, and is a retired pro wrestler.',
  },
  {
    name: 'Preston McNeil',
    pronouns: 'he/him',
    role: 'Player',
    image: preston,
    bio: 'Preston is excited to return to UMRX. After seven years with the show, it has become his favorite way to get into the holiday spirit. You may have seen him in Jet City productions including A Tribe Called Yes, Stabbin’ Cabin, Party Favors, and Journey of the Wind. Offstage, he is working on music you might hear one day.',
  },
  {
    name: 'Randy Miller',
    pronouns: 'he/him',
    role: 'Player',
    image: randy,
    bio: 'Randy has been improvising in Seattle for more than 15 years, and UMRX has become a staple of his holiday season. Randy is also an architect and woodworker. He believed in Santa until fifth grade.',
  },
  {
    name: 'Claudine Mboligikpelani Nako',
    pronouns: 'she/her',
    role: 'Production Manager',
    image: claudine,
    bio: 'Nako is the best. 💜',
  },
  {
    name: 'Kat Schelonka',
    pronouns: 'they/them/she/her',
    role: 'Player',
    image: kat,
    bio: 'Kat is a member of the Jet City Improv ensemble and the We Have Some Notes musical improv ensemble. Recent credits include The Rest of Us, Inside Voices, Selling Seattle, and the Vision Euro Song Contest at CSz Seattle.',
  },
  {
    name: 'Ian Schempp',
    pronouns: 'he/him',
    role: 'Player',
    image: ian,
    bio: 'Ian has been improvising since 1997, when he and some friends played some Whose Line Is It Anyway? games after school. They were terrible, and he loved every second. After moving to Seattle, he performed with Sisters of Sal and Jet City Improv, where he created shows including Shades of Gray, Unspeakable Horrors, and Funbucket. Uncle Mike is always a highlight of his year.',
  },
  {
    name: 'Rob Scherzer',
    pronouns: 'he/him',
    role: 'Marketing Manager, Producer, Musician',
    image: rob,
    bio: 'Rob plays the keys. That is both a job description and a warning.',
  },
  {
    name: 'Stephani Thompson',
    pronouns: 'she/they',
    role: 'Player',
    image: stephani,
    bio: 'Stephani Thompson is a born-and-raised Washingtonian who has spent 20 years improvising around Seattle. She performed with Jet City Improv and is an ensemble member at Unexpected Productions. For a time, she was Seattle’s only burlesque clown, Fanny Tragic. When she is not performing, she is flying a kite or looking for birds.',
  },
  {
    name: 'Anthony Van Winkle',
    pronouns: 'he/him',
    role: 'Technical Improviser',
    image: anthony,
    bio: 'Anthony is a technical improviser with more than 20 years of experience designing, directing, and improvising in some of Seattle’s most ambitious unscripted theatre. In his spare time, he designs and builds pinball machines.',
  },
  {
    name: 'Doug Willott',
    pronouns: 'he/him (all welcome)',
    role: 'Founder, Producer',
    image: doug,
    bio: 'Douglas Willott is a Seattle-born actor, director, and writer. At Jet City Improv, he created and directed Uncle Mike Ruins Christmas, Every Movie Is a Musical, and Funbucket. He has performed with Theatresports, CSz Seattle, and The Upfront in Bellingham, and has worked with many very funny people. The Uncle Mike team remains among his favorite collaborators.',
  },
];

export const galleryItems = [
  { image: gallery01, title: 'Nick and Jon', caption: 'Nick and Jon talk about the WTC.' },
  { image: gallery02, title: 'The neighbors', caption: 'Graham watches the neighbors.' },
  { image: gallery03, title: 'A Christmas delivery', caption: 'Uncle Mike delivers Stephani into Graham’s arms.' },
  { image: gallery04, title: 'Mime time', caption: 'Kayla gets acquainted with a ghost.' },
  { image: gallery05, title: 'Wizard of Oz', caption: 'The elves stage a tiny, tasteful tragedy.' },
  { image: gallery06, title: 'Removal', caption: 'The cast removes a body at Molly’s decree.' },
  { image: gallery07, title: 'Backwards hug', caption: 'Cousin Graham hugs Uncle Mike.' },
  { image: gallery08, title: 'Joyride', caption: 'Elena, Kayla, and Preston head out for Christmas cigarettes.' },
  { image: gallery09, title: 'Mommy letter', caption: 'Preston reads Mandy’s magazine for the articles.' },
  { image: gallery10, title: 'The fight', caption: 'The cast takes bets.' },
  { image: gallery11, title: 'American Idol', caption: 'Molly’s voice changes the holiday mood.' },
  { image: gallery12, title: 'Murphy and Thompson', caption: 'Uncle Mike and Stephani share the spirit of the season.' },
  { image: gallery13, title: 'Take a bow', caption: 'Nick presents himself before his canine suitors.' },
  { image: gallery14, title: 'Carolers', caption: 'Molly, Mandy, Jon, Nick, and Stephani carol in the cold.' },
  { image: gallery15, title: 'Pain', caption: 'Stephani hurts Elena’s feelings for a very good reason.' },
  { image: gallery16, title: 'Holiday brawl', caption: 'Molly and Stephani settle it the festive way.' },
  { image: gallery17, title: 'Pukefest', caption: 'Carol of the Puking Bells.' },
  { image: gallery18, title: 'The ending', caption: 'Narrator Doug ties everything up with a little bow.' },
  { image: gallery19, title: 'Togetherness', caption: 'A wholesome display of ensemble connection.' },
  { image: gallery20, title: 'Doggies', caption: 'Stephani feeds her dogs.' },
  { image: gallery21, title: 'Heimlich', caption: 'Nick dislodges a blockage from Graham.' },
  { image: gallery22, title: 'Bosom buddies', caption: 'Uncle Mike and Nick share a tender moment.' },
  { image: gallery23, title: 'Joy', caption: 'Mandy and Randy turn on the tree lights.' },
  { image: gallery24, title: 'Nick', caption: 'Nick brings an outsized stage presence.' },
  { image: gallery25, title: 'Ian', caption: 'Ian has a rough holiday.' },
];
